﻿import React, { useEffect, useState, forwardRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CircularProgress } from '@mui/material';
import RenderIcon from '../../pages/Software/Subpages/SoftwareList/RenderIcon';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { GenerateSSILink } from '../../api/software';

function SSILink({ children, onMouseEnter, onMouseLeave, ...props }, ref) {
  const [ssiData, setSSIData] = useState(null);

  const SSIURL = useQuery({
    queryKey: ['SSILink', props.id],
    queryFn: () => GenerateSSILink({ azureID: '', envInput: '' })(),
    enabled: false,
    gcTime: 0,
  });

  useEffect(() => {
    if (SSIURL.data) {
      setSSIData(SSIURL.data);
    }
  }, [SSIURL.data]);

  const [errorTimer, setErrorTimer] = useState(false);

  useEffect(() => {
    if (ssiData?.postBackUrl) {
      document.forms['frmSSI' + props.id].submit();
    }
  }, [SSIURL.data]);

  useEffect(() => {
    if (SSIURL.isError) {
      setTimeout(() => {
        setErrorTimer(true);
      }, 3000);
    }
  }, [SSIURL.isError]);

  const openSSIURL = () => {
    SSIURL.refetch();
  };

  if (SSIURL.isError && !SSIURL.isFetching) {
    if (errorTimer) {
      return (
        <div ref={ref}>
          <a
            onClick={() => {
              openSSIURL();
            }}
          >
            <RenderIcon>
              <ReplayOutlinedIcon />
            </RenderIcon>{' '}
            Click to retry
          </a>
        </div>
      );
    }
    return (
      <div ref={ref}>
        <RenderIcon>
          <LinkOffOutlinedIcon />
        </RenderIcon>
        Could not generate SSI Link
      </div>
    );
  }

  return (
    <div
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start', // Changed from 'center' to 'flex-start'
        height: '100%',
        width: '100%',
        paddingTop: '8px', // Add some top padding to match ButtonBase
      }}
    >
      <a
        onClick={() => {
          openSSIURL();
        }}
        style={{
          display: 'contents', // Makes <a> invisible to layout
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        {children}
        {SSIURL.isFetching && <CircularProgress size={16} />}
      </a>
      {SSIURL && SSIURL.data != null && ssiData != null && (
        <form action={ssiData?.postBackUrl} id={'frmSSI' + props.id} target="_blank" method="POST">
          <input
            type="hidden"
            id="SAMLResponse"
            name="SAMLResponse"
            value={ssiData?.samlResponse}
          />
          <input type="hidden" id="RelayState" name="RelayState" value={ssiData?.relayUrl} />
        </form>
      )}
    </div>
  );
}

export default forwardRef(SSILink);
